<style lang="scss" scoped>
@import "./webhook-attempts.modal";
</style>

<template>
    <div>
        <cc-modal :modal="modal" @close="close">
            <div slot="body" class="container-fluid pt-0 webhook-attempts-modal">
                <div class="row contents">
                    <div class="col-12">
                        <div class="cc-loader" :class="{ hidden: !is_loading }">
                            <img src="/images/loader.svg" />
                            <span>Carregando</span>
                        </div>

                        <div v-if="!is_loading && webhook_attempts.length === 0" class="no-data">
                            Nenhuma tentativa de webhook encontrada
                        </div>

                        <WebhookAttemptsTable v-if="!is_loading && webhook_attempts.length > 0" :webhook_attempts="webhook_attempts" />
                    </div>
                </div>

                <div class="footer" v-if="total_items > items_by_page_value">
                    <cc-pagination
                        :key="'pag'"
                        classes="orange"
                        :items_by_page_value="items_by_page_value"
                        :total="total_items"
                        :page="page"
                        :page_limit="9"
                        v-on:change="update_page($event)"
                    ></cc-pagination>
                </div>
            </div>
        </cc-modal>
    </div>
</template>

<script>
import ErrorHandlerService from "@/services/ErrorHandlerService";
import Pagination from "@/components/cliente/base-components/Pagination";
import RequestService from "@/services/v3/request.service";
import WebhookAttemptsTable from "./_table.component.vue";

export default {
    props: ["quotation_id"],
    components: {
        ccPagination: Pagination,
        WebhookAttemptsTable,
    },
    data() {
        return {
            webhook_attempts: [],
            page: 1,
            total_items: 0,
            items_by_page_value: 10,
            service: new RequestService(),
            is_loading: true,
            modal: {
                title: "Notificações Enviadas",
                subtitle: "Histórico de tentativas de envio de webhook para esta cotação",
                icon_title: "material-icons webhook",
                cancel_text: "Fechar",
                style: {
                    width: "95%",
                    height: "700px",
                },
            },
        };
    },
    methods: {
        close() {
            this.$emit("close");
        },
        load_webhook_attempts() {
            this.is_loading = true;

            this.service
                .webhook_attempts(this.quotation_id)
                .then((response) => response.data)
                .then((data) => {
                    this.webhook_attempts = data.map((attempt) => ({
                        ...attempt,
                        showDetails: false,
                    }));
                    this.total_items = data.length;
                    this.is_loading = false;
                })
                .catch((error) => {
                    this.is_loading = false;
                    ErrorHandlerService.handle(error, this.$store);
                });
        },
        update_page(page) {
            this.page = page;
            this.load_webhook_attempts();
        },
    },
    mounted() {
        this.load_webhook_attempts();
    },
};
</script>
